import React from 'react';
import { Image, StyleSheet } from 'react-native';

// Dimensions de référence du wordmark, et leur rapport — une largeur réduite garde le ratio.
export const WORDMARK_WIDTH = 210;
export const WORDMARK_RATIO = 40 / 210;

export interface BrandLogoProps {
  // 'mark' = marque carrée seule (pastilles : coaching, onboarding) ;
  // 'wordmark' = logotype horizontal A + « Horméia » (en-tête accueil), emplacement large et court.
  variant?: 'mark' | 'wordmark';
  // Taille de la marque (variant 'mark' nu) ; défaut 34.
  size?: number;
  // Largeur du wordmark. Défaut 210 — l'en-tête de l'accueil la réduit, trois contrôles y
  // partageant la rangée. La hauteur suit le ratio, `resizeMode` conserve les proportions.
  width?: number;
  testID?: string;
}

/**
 * Logo Horméia centralisé — choisit la bonne forme selon le contexte.
 *
 * Les deux fichiers sont DÉTOURÉS (RGBA, alpha réellement à 0 sur le fond) : le logo se pose
 * directement sur le fond de l'écran. Il n'y a donc plus ni pastille blanche ni coins arrondis à
 * `overflow: hidden` — ces contournements ne masquaient que le fond opaque cuit dans les anciens
 * PNG. Si un rectangle réapparaît un jour, c'est l'export du fichier qu'il faut reprendre, pas le
 * composant ni la couleur de fond de l'écran.
 *
 * CONDITION À CONNAÎTRE AVANT DE POSER CE LOGO AILLEURS : l'encre est fixe, et le mot « Horméia »
 * est en bleu nuit. Les douze emplacements actuels sont tous sur `grey50` ou `white`, où il se lit
 * parfaitement. Sur un fond SOMBRE il deviendrait quasi illisible, et la réponse ne serait pas de
 * remettre une pastille — qui rapporterait un rectangle clair au milieu du fond — mais de fournir
 * une variante d'asset à encre claire.
 */
export function BrandLogo({ variant = 'mark', size = 34, width, testID }: BrandLogoProps) {
  if (variant === 'wordmark') {
    return (
      <Image
        testID={testID}
        source={require('../../assets/logo-horizontal.png')}
        style={[styles.wordmark, width ? { width, height: Math.round(width * WORDMARK_RATIO) } : null]}
        resizeMode="contain"
      />
    );
  }

  return (
    <Image
      testID={testID}
      source={require('../../assets/logo-mark.png')}
      style={[styles.mark, { width: size, height: size }]}
      resizeMode="contain"
    />
  );
}

const styles = StyleSheet.create({
  mark: { width: 34, height: 34 },
  /**
   * Dimensions de l'ancien wordmark (AlternJob) reprises telles quelles à cet emplacement.
   *
   * `contain` rend l'image à l'intérieur de cette boîte sans la déformer : avec un fichier de
   * 1219 × 301 (~4,05:1), le logotype occupe 162 × 40 et le reste de la boîte est transparent.
   * Un remplacement au même rapport se substitue au pixel près ; à un autre rapport, c'est la
   * taille rendue qui change, et ces deux valeurs sont alors à revoir.
   */
  wordmark: { width: WORDMARK_WIDTH, height: Math.round(WORDMARK_WIDTH * WORDMARK_RATIO) },
});
